import AllCountries from '@apps/attention360/pages/progressiveSignUp/AllCountriesData';

const phoneData = AllCountries.map((c) => ({ ...c, label: `${c.label} (+${c.code})` }));
export default phoneData;
